import React, { useEffect, useRef, useState, Suspense, lazy } from "react";
import MediaQuery from "react-responsive";
import SpinnerLoader from "../Utils/SpinnerLoader";


const Banner = lazy(() => import("./BannerPost/BannerPost"));
const PressReleaseSection = lazy(() => import("./PressReleaseSection/PressReleaseSection"));
const VoiceSection = lazy(() => import("./VoicesSection/VoicesSection"));
const RamaSwamySection = lazy(() => import("./RamaSwamySection/RamaSwamySection"));
const MayorgaSection = lazy(() => import("./MayorgaSection/MayorgaSection"));
const TumisangSection = lazy(() => import("./TumisangSection/TumisangSection"));
const SponsorThankYouSection = lazy(() => import("./SponsorThankYouSection/SponsorThankYouSection"));
const Footer = lazy(() => import("../FooterNew/footerChanges"));

export default function EventBody({ themeId, eventType, eventCreatedUnderDomain, eventPageData, preEventData, isMobile, webpageData, carouselRef }) {

    const [showOtherComponents, setShowOtherComponents] = useState(false);


    // Handle Scroll to show other components
    useEffect(() => {
        const handleScroll = () => {
            const windowHeight = window.innerHeight;
            const documentHeight = document.body.offsetHeight;
            const scrollPosition =
                window.scrollY ||
                window.pageYOffset ||
                document.documentElement.scrollTop;
            const maxScroll = documentHeight - windowHeight;
            const percentage = (scrollPosition / maxScroll) * 100;

            if (percentage > 5) {
                setShowOtherComponents(true);
            }
        };

        window.addEventListener("scroll", handleScroll);

        // Clean up the scroll listener when the component unmounts
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);



    return (
        <div>
            <div className="position-relative">
                <Suspense fallback={<SpinnerLoader />}>
                    <Suspense fallback={<div />}>
                        <Banner />
                    </Suspense>

                    <div className="Special-background-Speaker">
                    <Suspense fallback={<div />}>
                        <PressReleaseSection webpageData={webpageData} />
                    </Suspense>
                    
                    <Suspense fallback={<div />}>
                        <VoiceSection webpageData={webpageData} />
                    </Suspense>
                    </div>

                    {showOtherComponents && (
                        <>
                            <div className="Special-background-Speaker">
                                <Suspense fallback={<div />}>
                                    <RamaSwamySection webpageData={webpageData} />
                                </Suspense>

                                <div className="mt-5">
                                    <Suspense fallback={<div />} >
                                        <MayorgaSection webpageData={webpageData} />
                                    </Suspense>
                                </div>

                                <div className="mt-5">
                                    <Suspense fallback={<div />} >
                                        <TumisangSection webpageData={webpageData} />
                                    </Suspense>
                                </div>

                            </div>


                            <Suspense fallback={<div />}>
                                <SponsorThankYouSection webpageData={webpageData} />
                            </Suspense>

                            <Suspense fallback={<SpinnerLoader />}>
                                <Footer
                                    themeId={themeId}
                                    eventType={eventType}
                                    eventCreatedUnderDomain={eventCreatedUnderDomain}
                                    webpageData={webpageData}
                                />
                            </Suspense>
                        </>
                    )}
                </Suspense>
            </div>
        </div>
    );
}